module.exports = __webpack_public_path__ + "static/media/DSC01858.f34d4586.jpg";